import React from 'react';
import Card from './Card';
import { ReactComponent as NavigationBottomIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-down.svg';

const MainSection = () => {
  const subTitleText = 'ONE PASS CLEAR PATH';
  const TitleText = 'K-PATHPORT';
  const mainBg = `${process.env.REACT_APP_ASSETS_URL}/Kpathport/img-kpathport-main.svg`;
  const mobileBg = `${process.env.REACT_APP_ASSETS_URL}/Kpathport/img-kpathport-mobilebg.svg`;

  return (
    <div
      className='relative flex flex-col items-start w-full h-full overflow-clip 
                    px-4 pt-6 pb-20
                    tabletH:px-10 tabletH:pt-[180px] tabletH:pb-[80px]
                    desktopL:px-20 desktopL:pt-[200px] desktopL:pb-[260px]'
    >
      {/* Mobile Background */}
      <div
        className='absolute inset-0 bg-center bg-no-repeat bg-cover tabletH:hidden'
        style={{ backgroundImage: `url(${mobileBg})` }}
      />
      {/* Tablet/Desktop Background */}
      <div
        className='absolute inset-0 hidden bg-center bg-no-repeat bg-cover tabletH:block'
        style={{ backgroundImage: `url(${mainBg})` }}
      />
      <div aria-hidden='true' className='absolute inset-0 pointer-events-none'>
        <div className='absolute inset-0' />
        <div className='absolute inset-0' />
      </div>
      {/* Mobile Layout */}
      <div className='relative z-10 flex flex-col items-center w-full tabletH:hidden'>
        <div className='flex flex-col items-center pb-5 pt-[60px] px-0 w-full '>
          <div className='relative flex flex-col items-start'>
            <p className='font-semibold leading-[120%] text-grayscale-gray04  [text-shadow:2px_0px_16px_rgba(255,231,185,0.3)] tracking-[-0.448px] text-[32px] whitespace-pre-wrap'>
              one pass
            </p>
          </div>
          <div className='relative flex flex-col items-start'>
            <p className='font-semibold leading-[120%] text-grayscale-gray04  [text-shadow:2px_0px_16px_rgba(255,231,185,0.3)] tracking-[-0.448px] text-[32px] whitespace-pre-wrap'>
              clear path
            </p>
          </div>
        </div>
        <div className='flex flex-col items-start not-italic pb-[110px] pt-0 px-0 w-[358px]'>
          <div className='flex font-semibold items-center justify-center mb-[-30px] pl-0 pr-5 py-0 w-full text-grayscale-gray04 [text-shadow:2px_0px_16px_rgba(255,231,185,0.3)]'>
            <p className='h-[150px] leading-[120%]  mr-[-20px] text-[130px] text-center tracking-[-1.82px] w-[106px] whitespace-pre-wrap'>
              K
            </p>
            <p className='leading-[140%] mr-[-20px] text-[58px] text-right tracking-[-0.812px]'>
              -pathport
            </p>
          </div>
          <div className='font-regular leading-[140%] mb-[-30px] text-[14px] text-grayscale-gray03 text-right w-full whitespace-pre-wrap'>
            <p className='mb-0'>아래 스탭들에 대한 통합 설명 한두줄</p>
            <p>아래 스탭들에 대한 통합 설명 한두줄</p>
          </div>
        </div>
        {/* Click steps indicator */}
        <div className='flex items-center justify-center gap-2 px-0 pt-0 pb-3'>
          <NavigationBottomIcon
            className='size-4 text-text-inverse'
            aria-hidden='true'
          />
          <p className='font-medium leading-[140%] text-[13px] text-text-inverse text-center'>
            click steps
          </p>
          <NavigationBottomIcon
            className='size-4 text-text-inverse'
            aria-hidden='true'
          />
        </div>
        <div className='w-full'>
          <Card />
        </div>
      </div>
      {/* Tablet/Desktop Layout */}
      <div className='hidden tabletH:flex tabletH:flex-col tabletH:items-start tabletH:w-full '>
        <div className='relative z-10 tabletH:flex tabletH:flex-col tabletH:items-start tabletH:p-0 tabletH:pb-0 mix-blend-plus-lighter'>
          <span
            className={`font-semibold leading-none text-grayscale-gray04 [text-shadow:2px_0px_16px_rgba(255,231,185,0.3)] tracking-[-0.672px]
                          tabletH:text-[48px]
                          desktopL:text-[90px]`}
          >
            {subTitleText}
          </span>
        </div>
        <div
          className='flex flex-col items-end w-full h-full relative z-10
                        tabletH:px-0 tabletH:pt-0 tabletH:pb-[60px] tabletH:gap-2
                        desktopL:px-0 desktopL:pt-0 desktopL:pb-[60px] desktopL:gap-2 mix-blend-plus-lighter'
        >
          <span
            className={`font-semibold leading-none text-grayscale-gray04 [text-shadow:2px_0px_16px_rgba(255,231,185,0.3)] tracking-[-1.204px] text-right w-full whitespace-pre-wrap
                            tabletH:text-[86px]
                            desktopL:text-[160px]`}
          >
            {TitleText}
          </span>
        </div>
        <div className='relative z-20 w-full tabletH:pt-0 tabletH:pb-0'>
          <Card />
        </div>
      </div>
    </div>
  );
};

export default MainSection;
